import axios from 'axios'

export default {
  data() {
    return {
      publications: [],
      openedBioRef: null,
      author: null,
      page: 1,
      pages: 1,
      loading: false
    }
  },
  methods: {
    viewPublications(_author, _page) {
      this.author = _author;

      var url = '/' + window.Laravel.code + '/ajax/publications/' + _author;

      if (_page > 1) {
        url += '?page=' + _page;
      }

      this.loading = true;

      axios
        .get(url)
        .then(response => {
          this.publications = response.data.data
          this.pages = response.data.last_page;
          this.page = response.data.current_page;
          this.loading = false;

          if (this.$refs['publications-modal'].isHidden) {
            this.$refs[this.openedBioRef].hide()
            this.$refs['publications-modal'].show()
          }
        })
    },
    saveBioRef(ref) {
      this.openedBioRef = ref
    },
    changePage(_page) {
      var $self = this

      this.$scrollTo('#publications-modal .bg-white', 2000, {
        container: "#publications-modal",
        cancelable: false,
        // onStart: false,
        onDone() {
          $self.viewPublications($self.author, _page)
        },
      })
    },
    backToBio() {
      this.$refs['publications-modal'].hide()
      this.$refs[this.openedBioRef].show()
    }
  }
}